import { render, staticRenderFns } from "./fccTodasCidadesProva.vue?vue&type=template&id=ab1530d4"
import script from "./fccTodasCidadesProva.vue?vue&type=script&lang=js"
export * from "./fccTodasCidadesProva.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports